"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBootstrapColor = exports.BOOTSTRAP_COLORS = exports.BootstrapColor = void 0;
/** Enumeration of colors provided by Bootstrap */
var BootstrapColor;
(function (BootstrapColor) {
    BootstrapColor["Primary"] = "primary";
    BootstrapColor["Secondary"] = "secondary";
    BootstrapColor["Success"] = "success";
    BootstrapColor["Danger"] = "danger";
    BootstrapColor["Warning"] = "warning";
    BootstrapColor["Info"] = "info";
    BootstrapColor["Light"] = "light";
    BootstrapColor["Dark"] = "dark";
})(BootstrapColor = exports.BootstrapColor || (exports.BootstrapColor = {}));
/** List of colors provided by bootstrap, mostly for iteration/testing purposes */
exports.BOOTSTRAP_COLORS = [
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "light",
    "dark",
];
/** Utility function to quickly verify whether a string is one of the named bootstrap theme colors */
var isBootstrapColor = function (color) {
    return exports.BOOTSTRAP_COLORS.includes(color);
};
exports.isBootstrapColor = isBootstrapColor;
